import * as React from "react";

export const IconManagementLedger = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="24" height="24" viewBox="22.5 6.5 27 27" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M32 21H40V19H32V21ZM32 24H40V22H32V24ZM32 27H37V25H32V27ZM30 30C29.45 30 28.98 29.8 28.59 29.41C28.2 29.02 28 28.55 28 28V12C28 11.45 28.2 10.98 28.59 10.59C28.98 10.2 29.45 10 30 10H38L44 16V28C44 28.55 43.8 29.02 43.41 29.41C43.02 29.8 42.55 30 42 30H30ZM37 17H42L37 12V17Z"
      fill="currentColor"
    />
  </svg>
);
